const AR_TZ = 'America/Argentina/Buenos_Aires';

const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

function isDateOnly(s) {
  return typeof s === 'string' && DATE_ONLY_RE.test(s.trim());
}

function parseUtc(isoString) {
  if (!isoString) return null;
  if (typeof isoString !== 'string') return new Date(isoString);
  if (isDateOnly(isoString)) {
    return new Date(isoString + 'T12:00:00Z');
  }
  const hasTz = /Z$|[+-]\d{2}:?\d{2}$/.test(isoString);
  return new Date(hasTz ? isoString : isoString + 'Z');
}

function formatCalendarDate(isoString, locale) {
  const [y, m, d] = isoString.trim().split('-');
  if (!y || !m || !d) return '';
  const lang = locale || 'es-AR';
  const localDate = new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10));
  if (isNaN(localDate.getTime())) return '';
  return localDate.toLocaleDateString(lang, { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function parseBackendDate(isoString) {
  return parseUtc(isoString);
}

export function formatDateAR(isoString, locale) {
  if (!isoString) return '';
  if (isDateOnly(isoString)) return formatCalendarDate(isoString, locale);
  const d = parseUtc(isoString);
  if (!d || isNaN(d.getTime())) return '';
  const lang = locale || 'es-AR';
  return d.toLocaleDateString(lang, { timeZone: AR_TZ, day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatDateTimeAR(isoString, locale) {
  const d = parseUtc(isoString);
  if (!d || isNaN(d.getTime())) return '';
  const lang = locale || 'es-AR';
  return d.toLocaleString(lang, {
    timeZone: AR_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function formatTimeAR(isoString, locale) {
  const d = parseUtc(isoString);
  if (!d || isNaN(d.getTime())) return '';
  const lang = locale || 'es-AR';
  return d.toLocaleTimeString(lang, { timeZone: AR_TZ, hour: '2-digit', minute: '2-digit', hour12: false });
}

export function formatMonthShortAR(isoString, locale) {
  if (isDateOnly(isoString)) {
    const [, m] = isoString.trim().split('-');
    const monthIdx = Math.max(0, Math.min(11, parseInt(m, 10) - 1));
    const tmp = new Date(2000, monthIdx, 15);
    const lang = locale || 'es-AR';
    return tmp.toLocaleDateString(lang, { month: 'short' }).toUpperCase().replace('.', '');
  }
  const d = parseUtc(isoString);
  if (!d || isNaN(d.getTime())) return '';
  const lang = locale || 'es-AR';
  return d.toLocaleDateString(lang, { timeZone: AR_TZ, month: 'short' }).toUpperCase().replace('.', '');
}

export function getDayAR(isoString) {
  if (isDateOnly(isoString)) {
    const [, , d] = isoString.trim().split('-');
    return d || '';
  }
  const d = parseUtc(isoString);
  if (!d || isNaN(d.getTime())) return '';
  const parts = new Intl.DateTimeFormat('es-AR', { timeZone: AR_TZ, day: '2-digit' }).format(d);
  return parts;
}
